module.exports = __webpack_public_path__ + "img/Airbnb-Hybrid-Stretches-Recharge-.b8273b53.jpg";